// Attachment limits. Free accounts get a per-file size cap and a per-item
// count cap; Premium lifts both. Cloudinary storage isn't unlimited and
// attachments are free, so video is the thing that needs a ceiling (a minute of
// phone video is ~75-125 MB; photos are shrunk to <1 MB before upload and
// voice notes are ~1 MB a minute, so neither is ever near the cap).
//
// This is a client-side check only. The hard stop lives in the Cloudinary
// upload preset's own max file size (set in the Cloudinary dashboard).
const MB = 1024 * 1024;

export const FREE_LIMITS = { maxBytes: 25 * MB, maxCount: 5 };
export const PREMIUM_LIMITS = { maxBytes: 100 * MB, maxCount: 20 };

export const limitsFor = (premium) => (premium ? PREMIUM_LIMITS : FREE_LIMITS);

const mb = (bytes) => Math.round(bytes / MB);

// Returns an error message, or "" when a file of `bytes` may be added to an
// item that already holds `count` attachments. Existing items over the count
// (saved before the cap) are never trimmed; they just can't take more.
export function checkAttachment({ bytes = 0, count = 0, premium = false }) {
  const { maxBytes, maxCount } = limitsFor(premium);
  if (count >= maxCount) {
    return premium
      ? `You can attach up to ${maxCount} files per item.`
      : `You can attach up to ${maxCount} files per item. Premium allows ${PREMIUM_LIMITS.maxCount}.`;
  }
  if (bytes > maxBytes) {
    return premium
      ? `That file is over ${mb(maxBytes)} MB.`
      : `That file is over ${mb(maxBytes)} MB. Premium allows files up to ${mb(PREMIUM_LIMITS.maxBytes)} MB.`;
  }
  return "";
}
